import { render } from "./ui-checkbox.vue?vue&type=template&id=f40c0920&scoped=true"
import script from "./ui-checkbox.vue?vue&type=script&lang=js"
export * from "./ui-checkbox.vue?vue&type=script&lang=js"

import "./ui-checkbox.vue?vue&type=style&index=0&id=f40c0920&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f40c0920"]])

export default __exports__